<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    // ID for the modal, to be used with v-b-modal.the-id
    modalId: {
      type: String,
      default: "delete-team-modal",
    },
  },

  data() {
    return {
      // The handle input value (as confirmation to delete)
      handle: "",

      // Whether the form is actively being submitted
      loading: false,
    };
  },

  computed: {
    // Number of workers in the team
    workerCount() {
      return this.teamStatistics.count;
    },

    // Mapped vuex state
    ...mapState(["teamStatistics"]),
    ...mapGetters(["activeTeam"]),
  },

  // When the component is created, fetch the team's workers
  async created() {
    await Promise.all([this.getTeamStatistics({})]);
  },

  methods: {
    // Delete the team and hide the modal
    async doDelete() {
      this.loading = true;
      let success = await this.deleteTeam();
      if (success) {
        this.hide();
      }
      this.loading = false;
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["getTeamStatistics", "deleteTeam", "getBillingInfo"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Delete Team"
    button-size="sm"
    hide-header-close
    :no-close-on-backdrop="loading"
  >
    <p>
      Are you sure you would like to delete the
      <b>#{{ activeTeam.handle }}</b>
      team?
    </p>

    <b-form-group
      id="team-handle-group"
      label="Please type the team handle to confirm:"
      label-for="team-handle"
      class="mt-3"
    >
      <b-form-input
        required
        id="team-handle"
        v-model="handle"
        placeholder="Team Handle"
      ></b-form-input>
    </b-form-group>
    <template #modal-footer>
      <div class="float-right">
        <b-button
          class="mr-3"
          :disabled="loading"
          variant="light"
          @click="hide"
        >
          Cancel
        </b-button>
        <b-button
          variant="danger"
          @click="doDelete"
          :disabled="loading || handle != activeTeam.handle"
          :loading="loading"
        >
          Delete team
          <span v-if="workerCount > 0">
            and {{ workerCount }} worker{{ workerCount != 1 ? "s" : "" }}
          </span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
